import { Box, Typography } from '@mui/material';
import { formatTemperature } from './WorkRestHelpers';

export interface WorkRestConditionSectionProps {
  adjustedValue: number | undefined;
  actualValue: number | undefined;
}

export function WorkRestConditionSection({ adjustedValue, actualValue }: WorkRestConditionSectionProps) {
  const displayAdjusted = formatTemperature(adjustedValue);
  const displayActual = formatTemperature(actualValue);  

  return (
    <Box display='flex' flexDirection='column' alignItems='start'>
      <Typography variant='h3' fontWeight='bold'>
        {displayAdjusted}
      </Typography>
      <Typography variant='body1' color='textSecondary'>
        Actual:{' '}
        <Typography component='span' fontWeight='light' color='textPrimary'>
          {displayActual}
        </Typography>
      </Typography>
    </Box>
  );
}
